// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"b1076b77","783":"9b16dba4"}[chunkId] + ".chunk.css";
};